import { render, staticRenderFns } from "./AppShellView.vue?vue&type=template&id=f99d254e&scoped=true&"
import script from "./AppShellView.vue?vue&type=script&lang=js&"
export * from "./AppShellView.vue?vue&type=script&lang=js&"
import style0 from "./AppShellView.vue?vue&type=style&index=0&id=f99d254e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99d254e",
  null
  
)

export default component.exports